import React from "react";

const Banner = () => {
  return (
    <div className="bg-gray-100 py-12 px-4 sm:px-6 flex justify-center">
      <div className="flex flex-col md:flex-row items-center md:items-start gap-10 max-w-6xl w-full">
        {/* Imagem */}
        <div className="w-full md:w-auto flex justify-center md:justify-start">
          <div className="border-[12px] sm:border-[16px] border-white-200 rounded-xl shadow-lg">
            <img
              src="banner/MELI01.JPG"
              alt="Meli Awards 2024"
              className="rounded-xl  w-full max-w-[1000px] h-auto"
            />
          </div>
        </div>
        {/* Texto */}
        <div className="w-full max-w-2xl text-center md:text-left px-2">
          <p className="text-slate-500 text-base sm:text-md leading-8 sm:leading-10 font-normal">
            É com muita felicidade que a <strong className="text-gray-900">BTS</strong> celebra a conquista do Prêmio 
            <strong className="text-gray-900"> Meli Awards</strong>, na categoria <strong className="text-gray-900">Real Estate Shipping</strong>.
            O Meli Awards é uma premiação destinada a reconhecer o desempenho dos melhores fornecedores do Mercado Livre,
            entre as mais de 2.800 empresas que compõem sua cadeia de suprimentos e serviços. Os critérios de avaliação
            incluíram produtividade, qualidade dos projetos, redução de custos, inovação e ESG.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Banner;
